import axios from 'axios';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/document/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/document/';

class DocumentService {

  getAllDocumentTypes() {
    return axios.get(API_URL  + 'types/');
  }

  getAllDocumentsVisible() {
    return axios.get(`${API_URL}`);
  }

  getAllDocumentsVisibleByPlayer(playerId) {
    return axios.get(`${API_URL}${playerId}`);
  }

  getAllDocumentsVisibleByGame(gameId) {
    return axios.get(`${API_URL}game/${gameId}`);
  }

  getAllGameDocumentsByEventCalendarId(gameId, eventId) {
    return axios.get(`${API_URL}game/${gameId}/${eventId}`);
  }

  getAllPlayerDocumentsByEventCalendarId(playerId, eventId) {
    return axios.get(`${API_URL}player/${playerId}/${eventId}`);
  }

  getAllTeamDocumentsByEventCalendarId(teamId, eventId) {
    return axios.get(`${API_URL}team/${teamId}/${eventId}`);
  }

  postDocument(document) {
    return axios.post(`${API_URL}`,document);
  }

  postGameDocument(document) {
    return axios.post(`${API_URL}game/`,document);
  }

  updateDocument(document) {
    return axios.put(`${API_URL}${document.id}`,document);
  }

  updateGameDocument(document) {
    return axios.put(`${API_URL}game/${document.id}`,document);
  }

  deleteDocument(document) {
    return axios.delete(`${API_URL}${document.id}`);
  }

  deleteGameDocument(document) {
    return axios.delete(`${API_URL}game/${document.id}`);
  }

  getDownloadURL(documentId,filename) {
    return axios.get(`${API_URL}${documentId}/downloadURL/${filename}`);
  }

  getGameDownloadURL(documentId,filename) {
    return axios.get(`${API_URL}game/${documentId}/downloadURL/${filename}`);
  }

  download(url){
    return axios.get(url);
  }

  getUploadURL(documentId,filename) {
    return axios.get(`${API_URL}${documentId}/uploadURL/${filename}`);
  }

  getGameUploadURL(documentId,filename) {
    return axios.get(`${API_URL}game/${documentId}/uploadURL/${filename}`);
  }

  getGameUploadURLs(documentIds,filenames) {
    return axios.get(`${API_URL}game/${documentIds}/uploadURLs/${filenames}`);
  }

  upload(url,file,config = {}){
    return axios.put(url,file,config);
  }

  getDeleteURL(documentId,filename) {
    return axios.get(`${API_URL}${documentId}/deleteURL/${filename}`);
  }

  getGameDeleteURL(documentId,filename) {
    return axios.get(`${API_URL}game/${documentId}/deleteURL/${filename}`);
  }

  delete(url){
    return axios.delete(url);
  }

  getJSONDownloadURL(gameId,filename){
    return axios.get(`${API_URL}vision/${gameId}/downloadURL/${filename}`);
  }

  getGameVideoUpoadURL(gameId,clientId,filename,mp4 = true){
    return axios.get(`${API_URL}game/${gameId}/client/${clientId}/uploadURL/${filename}`,{params:{mp4:mp4}});
  }

  getAllDocumentsVisibleByTeam(teamId) {
    return axios.get(`${API_URL}team/${teamId}`);
  }

  postTeamDocument(document) {
    return axios.post(`${API_URL}team/`, document);
  }

  getTeamUploadURL(documentId, filename) {
    return axios.get(`${API_URL}team/${documentId}/uploadURL/${filename}`);
  }

  getTeamDownloadURL(documentId, filename) {
    return axios.get(`${API_URL}team/${documentId}/downloadURL/${filename}`);
  }

  updateTeamDocument(document) {
    return axios.put(`${API_URL}team/${document.id}`, document);
  }

  deleteTeamDocument(document) {
    return axios.delete(`${API_URL}team/${document.id}`);
  }

  getTeamDeleteURL(documentId,filename) {
    return axios.get(`${API_URL}team/${documentId}/deleteURL/${filename}`);
  }

  getTeamCrestUploadURL(teamId,filename){
    return axios.get(`${API_URL}team/${teamId}/crest/uploadURL/${filename}`);
  }

  getLeagueLogoUploadURL(leagueId,filename){
    return axios.get(`${API_URL}league/${leagueId}/logo/uploadURL/${filename}`);
  }

  getPlayerFaceUploadURL(playerId,filename){
    return axios.get(`${API_URL}player/${playerId}/face/uploadURL/${filename}`);
  }

  //Event calendar documents

  getAllDocumentsVisibleByTask(taskId) {
    return axios.get(`${API_URL}event-calendar/${taskId}`);
  }

  postTaskDocument(document) {
    return axios.post(`${API_URL}event-calendar/`, document);
  }

  getTaskUploadURL(documentId, filename) {
    return axios.get(`${API_URL}event-calendar/${documentId}/uploadURL/${filename}`);
  }

  getTaskDownloadURL(documentId, filename) {
    return axios.get(`${API_URL}event-calendar/${documentId}/downloadURL/${filename}`);
  }

  updateTaskDocument(document) {
    return axios.put(`${API_URL}event-calendar/${document.id}`, document);
  }

  deleteTaskDocument(document) {
    return axios.delete(`${API_URL}event-calendar/${document.id}`);
  }

  getTaskDeleteURL(documentId,filename) {
    return axios.get(`${API_URL}event-calendar/${documentId}/deleteURL/${filename}`);
  }

  getAllExpensesVisibleByUser(userId) {
    return axios.get(`${API_URL}event-calendar/expenses/${userId}`);
  }

}

export default new DocumentService();
